module.exports = __webpack_public_path__ + "img/word-icon.80d2fe40.png";